import { withCompInfo } from '../../core/withCompInfo'
import { StateBoxDefinition, StateBoxProps, StateBoxCSSVars } from './types'

export const props = withCompInfo<StateBoxProps, StateBoxDefinition>(['compProps', 'skin'], ({ compProps, skin }) => {
	return {
		skin,
		hasShadowLayer: true,
		currentSlideIndex: 0,
		transitionDuration: compProps.transDuration * 1000,
		transition: compProps.transition,
		autoPlay: false,
	}
})

export const css = withCompInfo<StateBoxCSSVars, StateBoxDefinition>(
	['compProps', 'compLayout', 'skin'],
	({ compProps, compLayout }) => {
		const { transDuration } = compProps

		return {
			height: `${compLayout.height}px`,
			'--transition-duration': `${transDuration * 1000}ms`,
			'--nav-dot-section-display': 'none',
			'--nav-button-display': 'none',
		}
	}
)
